/* =============================================================================
   pl-v5.js — quinta ronda: marco + tarjeta, corte, causa raíz
   ========================================================================== */
(function () {
  'use strict';
  var ONX = (window.ONX = window.ONX || {});
  ONX.scenes = ONX.scenes || {};
  var A = function () { return window.anime; };

  /* --------------------------- marco + tarjeta: la pantalla queda fija y cada
     paso tiene su reposo (la transición ocupa solo el 35% de su tramo) ---------- */
  ONX.scenes['pl-marco'] = function (el, gsap) {
    var imgs = el.querySelectorAll('.pmk__img'), steps = el.querySelectorAll('.pmk__step');
    var bars = el.querySelectorAll('.pmk__bars b'), prg = el.querySelector('.pmk__prg'), num = el.querySelector('.pmk__num');
    var n = steps.length; if (!n) return;
    var tr = el.getAttribute('data-tr') || 'wipe';
    var hidden = tr === 'circle' ? 'circle(0% at 50% 50%)' : 'inset(0% 0% 0% 100% round 0px)';
    var shown = tr === 'circle' ? 'circle(75% at 50% 50%)' : 'inset(0% 0% 0% 0% round 0px)';
    gsap.set(imgs, { clipPath: hidden }); gsap.set(imgs[0], { clipPath: shown });
    gsap.set(steps, { autoAlpha: 0, y: 18 }); gsap.set(steps[0], { autoAlpha: 1, y: 0 });

    var tl = gsap.timeline({ defaults: { ease: 'power2.inOut' },
      scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 0.8,
        onUpdate: function (s) {
          var p = s.progress * n;
          bars.forEach(function (b, k) { b.style.transform = 'scaleX(' + Math.max(0, Math.min(1, p - k)).toFixed(3) + ')'; });
          var k = Math.min(n - 1, Math.floor(p * 0.9999));
          if (num) num.textContent = String(k + 1).padStart(2, '0');
          if (prg) prg.style.strokeDashoffset = (100 - Math.min(1, s.progress) * 100).toFixed(1);
        } } });
    imgs.forEach(function (im, i) {
      var pic = im.querySelector('img');
      if (pic) tl.fromTo(pic, { scale: 1.08 }, { scale: 1, ease: 'none', duration: 1 }, i);   // acercamiento suave en su reposo
    });
    for (var i = 1; i < n; i++) {
      var t = i - 0.38, prevPic = imgs[i - 1].querySelector('img');
      tl.to(imgs[i], { clipPath: shown, duration: 0.34, ease: 'power3.inOut' }, t);
      if (prevPic) tl.to(prevPic, tr === 'circle' ? { scale: 0.9, rotate: -4, duration: 0.34 } : { xPercent: -12, duration: 0.34 }, t);
      tl.to(steps[i - 1], { autoAlpha: 0, y: -14, duration: 0.14 }, t)
        .to(steps[i], { autoAlpha: 1, y: 0, duration: 0.18 }, t + 0.18);
    }
    tl.to({}, { duration: 0.2 });
  };

  /* ------------------------------------------------ corte a pantalla completa */
  ONX.scenes['pl-corte'] = function (el, gsap, ST, env) {
    var a = el.querySelector('.pct__panel--a'), b = el.querySelector('.pct__panel--b'), cut = el.querySelector('.pct__cut');
    var top = el.querySelector('.pct__half--top'), bot = el.querySelector('.pct__half--bot');
    var eye = el.querySelector('.pct__eyebrow'), sub = el.querySelector('.pct__sub');
    var ang = env.mobile ? -9 : -5;
    gsap.set(cut, { rotate: ang, scaleX: 0, transformOrigin: '0% 50%' });
    gsap.set(top, { xPercent: -16 }); gsap.set(bot, { xPercent: 16 });
    if (eye) gsap.set(eye, { autoAlpha: 0, y: 12 });
    if (sub) gsap.set(sub, { autoAlpha: 0, y: 20 });
    var tl = gsap.timeline({ defaults: { ease: 'power2.inOut' },
      scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 0.8 } });
    tl.to(cut, { scaleX: 1, duration: 0.18, ease: 'power2.out' }, 0.04)                 // 1 · la línea corta la pantalla
      .to(a, { yPercent: -105, xPercent: -8, rotate: -3, duration: 0.34 }, 0.24)         // 2 · los paneles se separan por el corte
      .to(b, { yPercent: 105, xPercent: 8, rotate: 3, duration: 0.34 }, 0.24)
      .to(cut, { autoAlpha: 0, duration: 0.08 }, 0.26)
      .to([top, bot], { xPercent: 0, duration: 0.3, ease: 'power3.out' }, 0.42)          // 3 · el titular partido se une
      .to(eye, { autoAlpha: 1, y: 0, duration: 0.12 }, 0.5)
      .to(sub, { autoAlpha: 1, y: 0, duration: 0.14 }, 0.66)
      .to({}, { duration: 0.2 });
  };

  /* ------------------------------------------------------------- causa raíz */
  function initCausa(root) {
    root.querySelectorAll('[data-pca-grid]').forEach(function (grid) {
      if (grid._ok) return; grid._ok = true;
      var count = grid.parentElement.querySelector('[data-pca-count]'), cards = grid.querySelectorAll('.pca__card');
      grid.addEventListener('click', function (e) {
        var c = e.target.closest('.pca__card'); if (!c) return;
        var on = c.getAttribute('aria-pressed') !== 'true';
        c.setAttribute('aria-pressed', on);
        if (A() && on) A().animate(c.querySelector('.pca__ck'), { scale: [0.4, 1.12], rotate: [-60, 0], duration: 600, ease: 'outBack(3)' });
        var k = grid.querySelectorAll('[aria-pressed="true"]').length;
        if (count) {
          var b = count.querySelector('b'), sp = count.querySelector('span');
          b.textContent = k;
          sp.textContent = k === 0 ? 'marca los tuyos' : (k === 1 ? 'te pasa — sigue bajando' : 'te pasan — todos vienen de lo mismo ↓');
          if (A()) A().animate(b, { scale: [1.5, 1], duration: 500, ease: 'outBack(2)' });
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initCausa(document); }); else initCausa(document);
  document.addEventListener('shopify:section:load', function (e) { initCausa(e.target); });

  ONX.scenes['pl-causa'] = function (el, gsap) {
    var cards = el.querySelectorAll('.pca__card');
    gsap.fromTo(cards, { rotateX: 50, y: 50, opacity: 0 }, { rotateX: 0, y: 0, opacity: 1, stagger: 0.08, duration: 0.8, ease: 'power3.out', clearProps: 'transform',
      scrollTrigger: { trigger: el.querySelector('.pca__grid'), start: 'top 82%' } });
    var root = el.querySelector('[data-pca-root]'); if (!root) return;
    var lines = root.querySelectorAll('.pca__line');
    lines.forEach(function (l) { var L = l.getTotalLength(); l.style.strokeDasharray = L; l.style.strokeDashoffset = L; });
    var tl = gsap.timeline({ scrollTrigger: { trigger: root, start: 'top 85%', end: 'top 30%', scrub: 0.6 } });
    tl.to(lines, { strokeDashoffset: 0, opacity: 1, stagger: 0.05, ease: 'none', duration: 0.6 }, 0)
      .from(root.querySelector('.pca__bulb'), { scale: 0, transformOrigin: '50% 50%', duration: 0.2, ease: 'back.out(3)' }, 0.55)
      .to(root.querySelector('.pca__glow'), { opacity: 0.8, duration: 0.2 }, 0.6)
      .from(root.querySelector('.pca__causa'), { y: 30, opacity: 0, duration: 0.25 }, 0.65);
    // la raíz "late" cuando ya está encendida
    gsap.to(root.querySelector('.pca__glow'), { scale: 1.35, transformOrigin: '50% 50%', opacity: 0.35, duration: 1.4, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 1 });
  };
})();
